import cn from 'classnames';
import React from 'react';
import Text from '../../components/Text';
import { TermsConditionsPropTypes } from '../../TermsConditions';
import stylesDefault from '../../styles.module.scss';
import styles from './styles.module.scss';

const TermsConditions = ({ name, description }) => {
  return (
    <div id="terms-conditions" className={cn(stylesDefault.termsConditions, styles.termsConditions)}>
      <div className={cn(stylesDefault.tabs, styles.tabs)}>
        <h1 className={cn(stylesDefault.tabLabel, styles.tabLabel)}>{name}</h1>
        <Text isActive content={description} className={styles.tabContent} />
      </div>
    </div>
  );
};

TermsConditions.propTypes = { ...TermsConditionsPropTypes };

export default TermsConditions;
